var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"auto","md":"10","lg":"8","xl":"6"}},[_c('h1',[_vm._v("Medlemmar")]),_c('MembersStats',{attrs:{"members":_vm.members}}),_c('MembersList',{attrs:{"members":_vm.members,"memberships":_vm.membershipFees}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }